import { render, staticRenderFns } from "./CitasCierreView.vue?vue&type=template&id=19941972"
import script from "./CitasCierreView.vue?vue&type=script&lang=js"
export * from "./CitasCierreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports